import React, { useEffect, useCallback, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  pauseOnHover: true,
  arrows: false,
};

const slides = [
  {
    src: 'https://accounts.swilerp.com/images/loginSlider1.png',
    caption: 'Mobile Apps: SwilPOS, SwilSORT, SwilDISPATCH and more — combined with Retailgraph, SwilERP Desktop & Web.',
  },
  {
    src: 'https://accounts.swilerp.com/images/loginSlider2.png',
    caption: 'Security: SQL Server backend safeguards your critical business data.',
  },
  {
    src: 'https://accounts.swilerp.com/images/loginSlider3.png',
    caption: 'SwilERP Web: Cloud-based application that empowers your Retail and Wholesale business.',
  },
];

const footerLinks = [
  { label: 'SWIL Learn',   href: 'https://learn.swindia.com/#/home' },
  { label: 'Beta Program', href: 'https://www.swindia.com/beta-program/' },
  { label: 'Blog',         href: 'https://www.swindia.com/swil-blog/' },
  { label: 'Contact',      href: 'https://www.swindia.com/contact-us/' },
];

function CopyLinkButton() {
  const [status, setStatus] = useState('idle');

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setStatus('copied');
      setTimeout(() => setStatus('idle'), 2000);
    } catch {
      setStatus('failed');
      setTimeout(() => setStatus('idle'), 2500);
    }
  }, []);

  return (
    <button
      type="button"
      className="notfound-copy-btn"
      onClick={handleCopy}
      aria-label={status === 'copied' ? 'Link copied!' : 'Copy page link'}
    >
      <i className={`bi ${status === 'copied' ? 'bi-check2' : 'bi-clipboard'}`} aria-hidden="true"></i>
      {status === 'copied' ? 'Copied!' : 'Copy link'}
    </button>
  );
}

const NotFoundPage = () => {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Page Not Found — SwilShare';
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="notfound-page">
      <div className="notfound-hero">
        <div className="notfound-card">
          <div className="notfound-slider-side">
            <Slider {...sliderSettings}>
              {slides.map((slide) => (
                <div key={slide.src}>
                  <img src={slide.src} alt={slide.caption} />
                  <p>{slide.caption}</p>
                </div>
              ))}
            </Slider>
          </div>

          <div className="notfound-message-side">
            <div className="notfound-code" aria-hidden="true">404</div>
            <h2 className="notfound-title">Transaction not found</h2>
            <p className="notfound-desc">
              This link has expired or is no longer valid. Please contact your vendor for a new link.
            </p>
            <div className="notfound-actions">
              <a
                href="https://www.swindia.com"
                className="notfound-cta"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-arrow-left" aria-hidden="true"></i>
                Back to Website
              </a>
              <CopyLinkButton />
            </div>
          </div>
        </div>
      </div>

      <div className="notfound-promo">
        <a href="https://www.swindia.com/swilerp-cloud/" target="_blank" rel="noreferrer">
          <img
            src="https://cdn.swindia.com/assets/images/newwebsiteImages/Home/erp_desktop_ftr.webp"
            alt="SwilERP — Power your Retail, Wholesale & Distribution Business"
          />
        </a>
      </div>

      <footer className="notfound-footer">
        <div className="notfound-footer-inner">
          <div className="notfound-footer-logo">
            <img src="/images/swil_logo1.png" alt="SWIL India" />
          </div>
          <nav className="notfound-footer-links" aria-label="Footer links">
            {footerLinks.map(({ label, href }) => (
              <a key={href} href={href} target="_blank" rel="noreferrer">
                {label}
              </a>
            ))}
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default NotFoundPage;
